import { render, staticRenderFns } from "./papersInfo.vue?vue&type=template&id=0f39941a&"
import script from "./papersInfo.vue?vue&type=script&lang=js&"
export * from "./papersInfo.vue?vue&type=script&lang=js&"
import style0 from "./papersInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports